import {Component} from '@angular/core';

@Component({
  selector: 'app-docs',
  templateUrl: './docs.component.html',
})
export class DocsComponent {
  constructor() {}
}
